module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-152x152.8d89fb69a5c84bc365fdeb2c4691be33.png";